import _ from 'lodash'
import axios from 'axios'
import createAuthRefreshInterceptor from 'axios-auth-refresh'
import { isEmpty } from './utils'
import { version } from '../../package.json'

const authAxios = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
})

function getAccessToken() {
  return localStorage.getItem('token')
}

authAxios.interceptors.request.use(
  function (config) {
    const token = getAccessToken()
    const bearer = `Bearer ${token}`

    config.headers.Authorization = bearer
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

const refreshToken = (failedRequest) => {
  const refresh_token = localStorage.getItem('refresh_token')
  const params = { refresh_token }
  return authAxios.post('/auth/vendor/token/', params, {
    headers: {
      'X-App-Name': 'Legacy-Portal',
      'X-App-Version': version,
      'X-Client-Platform': 'Web-ReactJS',
    },
  }).then((response) => {
    localStorage.setItem('token', response.data.token)
    localStorage.setItem('refresh_token', response.data.refresh_token)
    return Promise.resolve()
  })
}

createAuthRefreshInterceptor(authAxios, refreshToken, {
  statusCodes: [401, 403],
})

const isAuthError = (error) => {
  return (
    error &&
    error.response &&
    (error.response.status === 401 || error.response.status === 403)
  )
}

const getErrorMessage = (err) => {
  if (err && err.response && err.response.data) {
    let { extras, message } = err.response.data
    if (!_.isEmpty(extras) && !_.isEmpty(extras.errors)) {
      const { errors } = extras
      const _errors = errors.filter((e)=> !isEmpty(e.path))
      message = _errors.map((e) =>  e?.message).join(', ')
    }
    return message || 'Internal Server Error'
  } else return err.message || 'Internal Server Error'
}


const getErrorMessageBlob = async (err) => {
   const errorRes = JSON.parse(await err.response.data.text())
   let { message } = errorRes
       return message || "Internal Server Error"
 }
 

export default authAxios
export { isAuthError, getErrorMessage, getErrorMessageBlob }
